import api from "./api";
import apiMP from "./apimp";
import apiBlob from "./apiblob";
import Utils from "@/common/Utils";

class LeadershipService {
  getLeadership(params) {
    return api
      .post("/leadership/getLeadership", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }
  getLeadershipList(params) {
    return api
      .post("/leadership/getLeadershipList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipNaviList(params) {
    return api
      .post("/leadership/getLeadershipNaviList", params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }
  insertLeadership(params) {
    let apiUrl = '/leadership/insertLeadership'
    if(params['idx'])
      apiUrl = '/leadership/updateLeadership'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  deleteLeadership(params) {
    let apiUrl = '/leadership/deleteLeadership'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  updateLeadershipColumn(params) {
    let apiUrl = '/leadership/updateLeadershipColumn'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertLeadershipTask(params) {
    let apiUrl = '/leadership/insertLeadershipTask'
    if(params['idx'])
      apiUrl = '/leadership/updateLeadershipTask'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  copyLeadership(params) {
    let apiUrl = '/leadership/copyLeadership'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getMonitoringPeriodList(params) {
    let apiUrl = '/leadership/getMonitoringPeriodList'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getBookmarkList(params) {
    let apiUrl = '/leadership/getBookmarkList'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertBookmark(params) {
    let apiUrl = '/leadership/insertBookmark'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  deleteBookmark(params) {
    let apiUrl = '/leadership/deleteBookmark'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipTask(params) {
    let apiUrl = '/leadership/getLeadershipTask'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipContent(params) {
    let apiUrl = '/leadership/getLeadershipContent'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipContentList(params) {
    let apiUrl = '/leadership/getLeadershipContentList'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertLeadershipContent(params) {
    let apiUrl = '/leadership/insertLeadershipContent'
    if(params['idx'])
      apiUrl = '/leadership/updateLeadershipContent'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }
  getFreeBoard(params) {
    let apiUrl = '/leadership/getFreeBoard'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }
  insertFreeBoard(params) {
    let apiUrl = '/leadership/insertFreeBoard'
    if(!Utils.isEmpty(params.get('idx')) && params.get('idx') != 0)
      apiUrl = '/leadership/updateFreeBoard'
    return apiMP
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertFreeBoardAnswer(params) {
    let apiUrl = '/leadership/insertFreeBoardAnswer'
    return apiMP
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertFreeBoardFile(params) {
    let apiUrl = '/leadership/insertFreeBoardFile'
    return apiMP
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getQuiz(params) {
    let apiUrl = '/leadership/getQuiz'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertQuiz(params) {
    //let apiUrl = '/leadership/insertQuiz'
    //if(params.idx)
    let apiUrl = '/leadership/updateQuiz'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertQuizAnswer(params) {
    let apiUrl = '/leadership/insertQuizAnswer'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipMonitoring(params) {
    let apiUrl = '/leadership/getLeadershipMonitoring'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getMonitoringListFilter(params) {
    let apiUrl = '/leadership/getMonitoringListFilter'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertLeadershipMonitoring(params) {
    let apiUrl = '/leadership/insertLeadershipMonitoring'
    if(params.idx)
      apiUrl = '/leadership/updateLeadershipMonitoring'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getMonitoring(params) {
    let apiUrl = '/leadership/getMonitoring'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  insertMonitoringAnswer(params) {
    let apiUrl = '/leadership/insertMonitoringAnswer'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipMonitoringTargets(params) {
    let apiUrl = '/leadership/getLeadershipMonitoringTargets'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  updateColumnBbs(params) {
    let apiUrl = '/leadership/updateLeadershipColumn'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipSummary(params) {
    let apiUrl = '/leadership/getLeadershipSummary'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipMonitoringSummary(params) {
    let apiUrl = '/leadership/getLeadershipMonitoringSummary'
    return api
      .post(apiUrl, params)
      .then((response) => {
        if (response.data.success) {
          Utils.log(response.data)
        }

        return response.data;
      });
  }

  getLeadershipFileDownload(params) {
    let apiUrl = '/leadership/getLeadershipFileDownload'
    return apiBlob
      .post(apiUrl, params)
      .then((response) => {
        return response.data;
      });
  }

  getLeadershipFBFileList(params) {
    let apiUrl = '/leadership/getLeadershipFBFileList'
    return api
      .post(apiUrl, params)
      .then((response) => {
        return response.data;
      });
  }

  insertLeadershipInterview(params) {
    let apiUrl = '/leadership/insertLeadershipInterview'
    return api
      .post(apiUrl, params)
      .then((response) => {
        return response.data;
      });
  }

  getLeadershipFilter(params) {
    let apiUrl = '/leadership/getLeadershipFilter'
    return api
      .post(apiUrl, params)
      .then((response) => {
        return response.data;
      });
  }

  getLeadershipResultExcelList(params) {
    let apiUrl = '/leadership/getLeadershipResultExcelList'
    return api
      .post(apiUrl, params)
      .then((response) => {
        return response.data;
      });
  }
}

export default new LeadershipService();
